import { render, staticRenderFns } from "./CreateReviewList.vue?vue&type=template&id=79b85a58&scoped=true&"
import script from "./CreateReviewList.vue?vue&type=script&lang=js&"
export * from "./CreateReviewList.vue?vue&type=script&lang=js&"
import style0 from "./CreateReviewList.vue?vue&type=style&index=0&id=79b85a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b85a58",
  null
  
)

export default component.exports